import { Component } from '@angular/core';
import { HelperService } from 'src/app/shared/helpers/helper.service';

@Component({
  selector: 'app-finder-terms-of-use',
  templateUrl: './finder-terms-of-use.component.html',
  styleUrl: './finder-terms-of-use.component.scss'
})
export class FinderTermsOfUseComponent {

  constructor(public helperService: HelperService) {}

}
